import {
  Circle, Droplets, Volume2, Zap, Heart, Mountain, Sparkles, Rocket, Flame, Orbit,
  CloudRain, Smile, SmilePlus, Palette, Trash2, Square, Flower, TreeDeciduous, Turtle,
  Box, Star, CupSoda, Layers, Puzzle, Dumbbell, Scale,
} from 'lucide-react';

// Maps an app's `icon` name (in appConfig) to its Lucide component. Shared by
// the Dashboard grid and the logged-out Landing grid so both draw identically.
const iconMap = {
  Circle, Droplets, Volume2, Zap, Heart, Mountain, Sparkles, Rocket, Flame, Orbit,
  CloudRain, Smile, SmilePlus, Palette, Trash2, Square, Flower, TreeDeciduous, Turtle,
  Box, Star, CupSoda, Layers, Puzzle, Dumbbell, Scale,
};

export default iconMap;
